import { fetchHighlightMatches } from '@ms/api/match'
import useCreateMatches from '@ms/components/match/useCreateMatches.js'

export default function useHighlights() {
  const { leagues: highlightMatches, resetLeagues, setLeagues } = useCreateMatches('league')

  const resetHighlightMatches = () => resetLeagues()

  // 获取 Highlight 足球比赛
  async function getHighlightMatches(sportId = '') {
    const { error, data } = await fetchHighlightMatches(sportId)
    if (error) {
      return Promise.reject(error)
    }

    setLeagues(data.tournaments)
  }

  return {
    highlightMatches,
    resetHighlightMatches,
    getHighlightMatches
  }
}
